import { createForm } from '../../../factories'

export default createForm(['groupIDs'])



// WEBPACK FOOTER //
// ./src/store/modules/modules/forms/relateGroups.js